import * as Library from "../../../utils/Library";

// #region REQUESTS
export async function requestDashboardData({ setLoader }) {
    const res = await Library.makeApiRequest({
        endpoint: "getDashboardData",
        setLoader
    });

    if (res?.data?.status !== 200) return undefined;
    return res?.data?.data ?? null;
}
// #endregion
